import React from 'react';
import { Checkbox } from 'antd';
import { Pagination } from 'components/common';
import { CategoryCheckboxListProps } from 'types';

const CategoryCheckboxList: React.FC<CategoryCheckboxListProps> = ({
  title,
  categories,
  checkedIds,
  onCheckedIdsChange,
  selectionCount,
  totalCount,
  className = '',
  pagination,
  onPageChange,
}) => {
  const handleCheck = (categoryId: string, checked: boolean) => {
    let newCheckedIds = [...checkedIds];
    if (checked) {
      newCheckedIds.push(categoryId);
    } else {
      newCheckedIds = newCheckedIds.filter((id) => id !== categoryId);
    }
    onCheckedIdsChange(newCheckedIds);
  };

  const handleSelectAll = (checked: boolean) => {
    if (checked) {
      onCheckedIdsChange(categories.map((cat) => cat.id));
    } else {
      onCheckedIdsChange([]);
    }
  };
  const shouldCheckAllCheckbox = () => {
    if (categories.length === 0) return false;
    return categories.every((cat) => checkedIds.includes(cat.id));
  };

  return (
    <div
      className={`border rounded-md flex flex-col sm:h-[250px] md:h-[300px] lg:h-[350px] xl:h-[400px] 2xl:h-[500px] min-[1800px]:h-[50vh] ${className}`}
    >
      <div className='p-2 border-b h-[40px]'>
        <div className='flex justify-between items-center'>
          <span className='font-bold text-[14px] leading-[20px]'>{title}</span>
          <span className='text-[14px] leading-[20px]'>
            {selectionCount !== undefined &&
              `Đang chọn (${selectionCount}/${(totalCount !== undefined && totalCount) || 0})`}
          </span>
        </div>
      </div>

      <div className='flex-1 flex flex-col overflow-hidden '>
        <div className='p-3 overflow-y-auto h-full'>
          <div className={`py-2 pl-[8px] flex items-center border-b ${shouldCheckAllCheckbox() ? 'bg-blue-50' : ''}`}>
            <Checkbox
              className='flex items-center'
              onChange={(e) => handleSelectAll(e.target.checked)}
              checked={shouldCheckAllCheckbox()}
              indeterminate={false}
            >
              Tất cả
            </Checkbox>
          </div>
          <div className='overflow-y-auto'>
            {categories.map((category) => (
              <div
                key={category.id}
                className={`py-2 flex items-center border-b ${checkedIds.includes(category.id) ? 'bg-blue-50' : ''}`}
                style={{ paddingLeft: 8 }}
              >
                <Checkbox
                  checked={checkedIds.includes(category.id)}
                  indeterminate={false}
                  onChange={(e) => handleCheck(category.id, e.target.checked)}
                >
                  {category.name}
                </Checkbox>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className='border-t h-[60px] '>
        <Pagination
          className='!justify-center !p-2'
          current={pagination.current}
          total={pagination.total}
          pageSize={pagination.pageSize}
          onChange={onPageChange}
          showSizeChanger={false}
          maxVisiblePages={3}
          showTotal={false}
        />
      </div>
    </div>
  );
};

export default CategoryCheckboxList;
